import React from 'react';

import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useTranslation } from 'react-i18next';

import { AddedText } from './styles';

extend(relativeTime);

type AddedAtDate = {
    addedDate: string;
};

export const AddedAt = ({ addedDate }: AddedAtDate) => {
    const { t } = useTranslation('yat_connect');

    if (addedDate == null) return null;

    const date = dayjs(new Date(addedDate));
    const now = dayjs();

    const isJustNow = now.diff(date, 'minutes') < 10;
    const isToday = now.diff(date, 'days') < 1;
    const isThisYear = now.year() == date.year();

    let dateTimeAgo = date.format('MMM D YYYY');

    if (isJustNow) {
        dateTimeAgo = 'Just now';
    } else if (isToday) {
        dateTimeAgo = date.fromNow();
    } else if (isThisYear) {
        dateTimeAgo = date.format('MMM D');
    }

    return <AddedText>{`${t('twitter_in_app_added_label')} ${dateTimeAgo}`}</AddedText>;
};
